import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./locations.css";

function Locations() {
  // -----------------------------------------
  // LOCATIONS STATE
  // -----------------------------------------
  const [locations, setLocations] = useState([


           {
         id: 20,
      name: "Eye Care Clinic & Optical",
      location: "Colombo 08",
      phone: "+94112682277", 
      googleMap: "https://share.google/nuYSdVZ3bIMFjUPj8",
      images: [
        "/shops/eye care/1.jpeg",
  
    
      ],
      currentIndex: 0,
    },

    {
      id: 1,
      name: "Wijesundara Optometrist",
      location: "Kuruwita",
      phone: "+94779544263", 
      googleMap: "https://share.google/m0bP9Pk9mqVgqU0Qh",
      images: [
        "/shops/BLGR-WIJESUNDARA/1.jpg",
       
      ],
      currentIndex: 0,
    },
    {
      id: 2,
      name: "Family Vision Center",
      location: "Kottawa",
      phone: "+94774412388", 
      googleMap: "https://maps.app.goo.gl/Q6MGxAutDgqubwYS6",
      images: [
        "/shops/DharshiLekha/1.jpeg",
       
      ],
      currentIndex: 0,
    },
    {
      id: 3,
      name: "Gamage Opticals Pvt Ltd",
      location: "Nawalapitiya",
      phone: "+94542222959", 
      googleMap: "https://maps.app.goo.gl/fCuiKwWM3wD5k1uL6?g_st=iw",
      images: [
        "/shops/DilrukshiGamage/1.jpeg",
        
      ],
      currentIndex: 0,
    },
    {
      id: 4,
      name: "Deneth Opticians",
      location: "Avissawella",
      phone: "+94761017763", 
      googleMap: "https://share.google/3ReLp6R5dohCoj0jQ",
      images: [
        "/shops/DilshaniSamudika/1.jpg",
    
      ],
      currentIndex: 0,
    },
    {
      id: 5,
      name: "Anura Opticians",
      location: "Panadura",
      phone: "+94382231969", 
      googleMap: "https://maps.app.goo.gl/N6HP7Tnaxh2PkEUo9",
      images: [
        "/shops/AnuraPerera/2.jpg",
     
      ],
      currentIndex: 0,
    },
    {
      id: 6,
      name: "Ganeesha Optical",
      location: "Tangalle",
      phone: "", 
      googleMap: "https://share.google/D2U992QvK5ktzqNF8",
      images: [
        "/shops/GGMadushani/1.jpg",

      ],
      currentIndex: 0,
    },
    {
      id: 7,
      name: "Marasinghe Optician",
      location: "Marawila",
      phone: "+94779573242", 
      googleMap: "https://share.google/BgYiOu1f2yLT1ttmd",
      images: [
        "/shops/Namali/1.jpeg",

      ],
      currentIndex: 0,
    },
    {
      id: 8,
      name: "Nethini Eye Care Pvt Ltd",
      location: "Wattala",
      phone: "+94112948777", 
      googleMap: "https://share.google/TX4a3bX1oq0BXvkfv",
      images: [
        "/shops/PrabhaAPerera/1.jpg",
    
      ],
      currentIndex: 0,
    },
        {
      id: 9,
      name: "Vienna Health and Eye Care",
      location: "Ja-Ela",
      phone: "+94114344420", 
      googleMap: "https://share.google/STaSmpt0P6p2DK45D",
      images: [
        "/shops/gomis/1.JPG",
  
      ],
      currentIndex: 0,
    },
        {
      id: 10,
      name: "Opasroo Vision Care",
      location: "Kalagedihena",
      phone: "+94715878636", 
      googleMap: "https://maps.app.goo.gl/d6wFv1MBXGPas9hp9",
      images: [
        "/shops/anusha/1.jpg",
        
      ],
      currentIndex: 0,
    },
    {
      id: 11,
      name: "Neth Optometrist and Pharmacy",
      location: "Kolonnawa",
      phone: "+94112532153", 
      googleMap: "https://maps.app.goo.gl/WSw6Qwa3GkC8dKXs8",
      images: [
        "/shops/UdeniGurusinghe/1.jpeg",
      
      
      ],
      currentIndex: 0,
    },

    {
      id: 12,
      name: "Colombo Opticians",
      location: "Colombo 14",
      phone: "+94112335882", 
      googleMap: "https://share.google/iNoir42sk2wkqwgHc",
      images: [
        "/shops/SurangaDeSilva/1.jpg",
        
     
      ],
      currentIndex: 0,
    },
        {
      id: 13,
      name: "Kandy Nisakma Optical",
      location: "Kandy",
      phone: "+94779051085", 
      googleMap: "https://maps.app.goo.gl/iVrMqHqWTKHwZxtE8?g_st=iwb",
      images: [
        "/shops/neil/1.jpeg",

      ],
      currentIndex: 0,
    },
            {
      id: 14,
      name: "City optical",
      location: "Kattankudy",
      phone: "+94779583437", 
      googleMap: "https://share.google/WPiI7fNOoFhpFKikc",
      images: [
        "/shops/sameel/1.jpeg",
  
    
      ],
      currentIndex: 0,
    },
                {
      id: 15,
      name: "Bernard wijethunga opticals & vision center",
      location: "Kadawatha",
      phone: "+94712116930", 
      googleMap: "https://maps.app.goo.gl/EzgbRcZ4NZoaJfjG6",
      images: [
        "/shops/Sujanima/1.jpeg",

    
      ],
      currentIndex: 0,
    },

                    {
      id: 16,
      name: "H M S Siriwardhane Optometrists",
      location: "Ja-Ela",
      phone: "+94112229822", 
      googleMap: "https://share.google/u1b5qggWiQII17EG6",
      images: [
        "/shops/prabhamali/1.jpeg",
  
  
    
      ],
      currentIndex: 0,
    },


                        {
      id: 17,
      name: "Green Eye Optical & Opticare",
      location: "Katana",
      phone: "+94711200705", 
      googleMap: "https://maps.app.goo.gl/CfpMP3y8seM4JwRo7",
      images: [
        "/shops/Vajira/1.jpeg",

      ],
      currentIndex: 0,
    },

                            {
      id: 18,
      name: "Royal Opticare (Pvt) Ltd",
      location: "Puttalam",
      phone: "+94767780850", 
      googleMap: "https://share.google/fAAg8zxILpID2nL5N",
      images: [
        "/shops/sameerah/1.jpg",
 
    
      ],
      currentIndex: 0,
    },

          {
         id: 19,
      name: "Vision Eye Care",
      location: "Katubedda",
      phone: "+94717570360", 
      googleMap: "https://maps.app.goo.gl/wXKLUdPiWC1fVtuFA?g_st=ic",
      images: [
        "/shops/lahiru/1.jpeg",
       
    
      ],
      currentIndex: 0,
    },

    
            {
         id: 21,
      name: "Sun Optic & Eye Clinic",
      location: "Colombo 10",
      phone: "+94777918989", 
      googleMap: "https://share.google/viXIuHvGBhUUuPcij",
      images: [
        "/shops/sun optic/1.jpg",

    
      ],
      currentIndex: 0,
    },


                {
         id: 22,
      name: "Nawagamuwa Optical Service",
      location: "Minuwangoda",
       phone: "+94112288300", 
      googleMap: "https://maps.app.goo.gl/YcMZYoxtuEuyQggv6",
      images: [
        "/shops/dhanawardane/1.jpg",
     
     
    
      ],
      currentIndex: 0,
    },


                    {
         id: 23,
      name: "Gampaha Optical Pvt(Ltd)",
      location: "Gampaha",
       phone: "+94775178288", 
      googleMap: "https://share.google/xYN8JHogtexNdmY5b",
      images: [
        "/shops/thalansuriya/1.jpg",
     

     
    
      ],
      currentIndex: 0,
    },


{
  id: 23,
  name: "Vision Concept",
  location: "Dehiwala-Mount Lavinia",
  phone: "+94112765512", 
  googleMap: "https://share.google/SUsUTGxZrIFJ9yJW2",
  images: [
    "/shops/eranda/1.jpeg",

  ],
  currentIndex: 0,
},

{
  id: 24,
  name: "H. M. S. Siriwardhane Optometrists",
  location: "Ratmalana",
  phone: "075 719 8893", 
  googleMap: "",
  images: [
    "/shops/erandi/1.jpeg",


  ],
  currentIndex: 0,
},

{
  id: 25,
  name: "Adil Eye And Vision Center",
  location: "Veyangoda",
  phone: "0333 555 412", 
  googleMap: "https://share.google/jZbj3DlPbvvVxfU2I",
  images: [
    "/shops/sadun/1.jpeg",


  ],
  currentIndex: 0,
},


  ]);

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");

  // Get unique locations for filter dropdown
  const uniqueLocations = [...new Set(locations.map(loc => loc.location))];

  // Filter locations based on search term and location filter
  const filteredLocations = locations.filter(location => {
    const matchesSearch = location.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                          location.location.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesLocation = selectedLocation === "" || location.location === selectedLocation;
    return matchesSearch && matchesLocation;
  });

  // -----------------------------------------
  // IMAGE SLIDER FUNCTIONS
  // -----------------------------------------
  const handleNextImage = (id) => {
    setLocations((prev) =>
      prev.map((loc) =>
        loc.id === id
          ? { ...loc, currentIndex: (loc.currentIndex + 1) % loc.images.length }
          : loc
      )
    );
  };

  const handlePrevImage = (id) => {
    setLocations((prev) =>
      prev.map((loc) =>
        loc.id === id
          ? {
              ...loc,
              currentIndex:
                (loc.currentIndex - 1 + loc.images.length) % loc.images.length,
            }
          : loc
      )
    );
  };

  // Clear all filters
  const clearFilters = () => {
    setSearchTerm("");
    setSelectedLocation("");
  };

  // -----------------------------------------
  // JSX RETURN - One row per location (compact view)
  // -----------------------------------------
  return (
    <section id="locations" className="locations-section">
      <div className="locations-container">
        {/* Header */}
        <div className="locations-header">
          <h1>All Optica Locations</h1>
          <p>Find trusted Eye Clinic & optical retailers across Sri Lanka</p>
        </div>

        {/* Search Panel - Top */}
        <div className="search-panel">
          <div className="search-box">
            

            <input
              type="text"
              placeholder=" Search by shop name or location..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
          
            {searchTerm && (
              <button className="clear-btn" onClick={() => setSearchTerm("")}>
                ✕
              </button>
            )}
          </div>

          <div className="filter-box">
            <select
              value={selectedLocation}
              onChange={(e) => setSelectedLocation(e.target.value)}
              className="location-select"
            >
              <option value="">All Locations</option>
              {uniqueLocations.map((loc, index) => (
                <option key={index} value={loc}>
                  {loc}
                </option>
              ))}
            </select>
          </div>

          {(searchTerm || selectedLocation) && (
            <button className="clear-filters-btn" onClick={clearFilters}>
              Clear All
            </button>
          )}
        </div>

        {/* Results Count */}
        <div className="results-count">
          Found {filteredLocations.length} {filteredLocations.length === 1 ? "location" : "locations"}
        </div>

        {/* Locations List - One row per location */}
        <div className="locations-list">
          <AnimatePresence>
            {filteredLocations.map((location, index) => (
              <motion.div
                className="location-row"
                key={location.id}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 20 }}
                transition={{ duration: 0.3, delay: index * 0.05 }}
                whileHover={{ scale: 1.01 }}
              >
                {/* Image Slider - Small thumbnail */}
                <div className="row-image-container">
                  <img
                    src={location.images[location.currentIndex]}
                    alt={location.name}
                    className="row-image"
                  />
                  {location.images.length > 1 && (
                    <>
                      <button
                        className="row-nav prev"
                        onClick={() => handlePrevImage(location.id)}
                      >
                        ‹
                      </button>
                      <button
                        className="row-nav next"
                        onClick={() => handleNextImage(location.id)}
                      >
                        ›
                      </button>
                      <span className="image-badge">
                        {location.currentIndex + 1}/{location.images.length}
                      </span>
                    </>
                  )}
                </div>

                {/* Location Info */}
                <div className="row-info">
                  <h3 className="shop-name">{location.name}</h3>
                  <div className="location-tag">
                    <span className="pin-icon">📍</span>
                    <span>{location.location}</span>

                            <a
  href={`tel:${location.phone}`}
  className="btn-call"
>
  {location.phone}
</a>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="row-actions">
                  <a
                    href={location.googleMap}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="directions-btn"
                  >
                    🗺️ Get Directions
                  </a>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </div>

        {/* No Results Message */}
        {filteredLocations.length === 0 && (
          <motion.div
            className="no-results"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            <span className="no-results-icon">🔍</span>
            <h3>No locations found</h3>
            <p>Try searching with a different term or clear the filters</p>
            <button onClick={clearFilters} className="reset-btn">
              Clear Filters
            </button>
          </motion.div>
        )}
      </div>
    </section>
  );
}

export default Locations;